class SliderVideoAutoplay {
  constructor (slider) {
    this.slider = slider;
    this.activeTimeout = null;
    this.observer = new IntersectionObserver(
      (entries) => {
        this.observerHandler(entries);
      },
      {
        root: null,
        rootMargin: '-15%',
      }
    );
  }
  startAutoplay (slider) {
    const currSlider = slider.find('.oxygen-unslider-container');
    const sliderObj = currSlider.data('unslider');
    const delay = sliderObj.options.delay;
    sliderObj.destroySwipe();
    currSlider.find('.unslider-active video')[0].play();
    // append progress bar to pagination
    currSlider.siblings('.unslider-nav').find('li').append('<span></span>');
    currSlider.siblings('.unslider-nav').find('li span').css('animation-duration',`${delay}ms`);
    this.activeTimeout = setTimeout(() => {
      sliderObj.next();
    }, delay);
  }
  sliderOnChange (slider) {
    const currSlider = slider.find('.oxygen-unslider-container');
    const sliderObj = currSlider.data('unslider');
    const delay = sliderObj.options.delay;
    const length = sliderObj.total;
    currSlider.on('unslider.change', function(event, index) {
      const currIndex = (index < length - 2) ? index : 0; // 2 cloned slides for infinte option
      currSlider.find('video').each((id, vdo) => {
        $(vdo)[0].pause();
      });
      const currVdo = $(sliderObj.$slides[currIndex]).find('video')[0];
      currVdo.currentTime = 0;
      currVdo.play();
      clearTimeout(this.activeTimeout);
      this.activeTimeout = setInterval(() => {
        currSlider.data('unslider').next();
      }, delay);
      if(index >= length - 3) {
        // append second last slide to fix the glitch
        const prevSlide = currSlider.find('.unslider-wrap > li').eq(2);
        currSlider.find('.unslider-wrap').append(prevSlide.clone().addClass('additional-slide'));
        // take the current time and seek to that time prevent quick change of the frame
        const vdoPausedTime = prevSlide.find('video')[0].currentTime;
        currSlider.find('.additional-slide video')[0].currentTime = vdoPausedTime;
        currSlider.find('.additional-slide video')[0].play();
        currSlider.find('.additional-slide video')[0].pause();
      } else {
        currSlider.find('.additional-slide').remove();
      }
    });
  }
  observerHandler(entries) {
    if (entries[0].isIntersecting) {
      this.startAutoplay(this.slider);
      this.sliderOnChange(this.slider);
      this.observer.disconnect();
    }
  }
  init () {
    this.observer.observe(this.slider[0]);
  }
}

$(() => {
  const sliders = $('.slider-autoplay-video');
  if (sliders.length == 0) {
    return;
  }
  sliders.each((id, slider) => {
    const sliderEl = $(slider);
    const sliderAutoplay = new SliderVideoAutoplay(sliderEl);
    sliderAutoplay.init();
  });
});
